<!--
 * @Title: 标题
 * @Description: 描述供应链
 * @Author: xulongyong
 * @Date: 2023-09-10 09:18:14
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-10 09:18:15
 * @FilePath: \vue-privilege-routing\src\pages\business\supply-chain\index.vue
-->
<template>
    <div>
       仓储管理
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
